<template>
	<v-app dark>
		<v-toolbar app>
			<v-toolbar-title class="headline text-uppercase">
				<div>
					<span>JENNIFER</span>
					<span class="font-weight-light">_GILLAR SMINK</span>
				</div>
			</v-toolbar-title>

			<div v-if="$store.state.token">
				<v-btn icon to="add">
					<v-icon>add</v-icon>
				</v-btn>
				<v-btn
					@click="logOut(firebase)"
					:disabled="!$store.state.configChanged"
					icon
				>
					<v-icon>save</v-icon>
				</v-btn>
				<v-btn @click="logOut(firebase)" icon>
					<v-icon>exit_to_app</v-icon>
				</v-btn>
			</div>
			<v-spacer></v-spacer>
			<v-toolbar-items class="hidden-sm-and-down">
				<v-btn
					v-for="item in menu"
					:key="item.title"
					active-class="activeMenuItem"
					:to="item.link"
					flat
					>{{ item.title }}</v-btn
				>
				<v-menu offset-y>
					<template v-slot:activator="{ on }">
						<v-btn
							:class="{
								activeMenuItem:
									$router.currentRoute.name === 'portfolio'
							}"
							flat
							v-on="on"
							>Portfolio</v-btn
						>
					</template>
					<v-list>
						<v-list-tile
							active-class="activeMenuItem"
							v-for="(category, index) in categories"
							to="portfolio"
							:key="index"
							@click="changeCategory(category)"
						>
							<v-list-tile-title>{{
								category.toUpperCase()
							}}</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-menu>
			</v-toolbar-items>
			<v-menu class="hidden-md-and-up" :close-on-content-click="false">
				<v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
				<v-list>
					<v-list-tile
						v-for="item in menu"
						active-class="activeMenuItem"
						:key="item.title"
						:to="item.link"
					>
						<v-list-tile-content>
							<v-list-tile-title>{{ item.title }}</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>

					<v-list-group v-model="portfolio.expanded">
						<template v-slot:activator>
							<v-list-tile
								:class="{
									activeMobileMenuItem:
										$router.currentRoute.name === 'portfolio' &&
										!portfolio.expanded
								}"
							>
								<v-list-tile-content>
									<v-list-tile-title>PORTFOLIO</v-list-tile-title>
								</v-list-tile-content>
							</v-list-tile>
						</template>

						<v-list-tile
							v-for="category in categories"
							:key="category.index"
							@click="changeCategory(category)"
							to="portfolio"
							:class="{
								activeMobileMenuItem:
									$router.currentRoute.name === 'portfolio' &&
									portfolio.expanded &&
									$store.state.selectedCategory === category
							}"
						>
							<v-list-tile-content>
								<v-list-tile-title>
									<span style="color: white">{{
										category.toUpperCase()
									}}</span>
								</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list-group>
				</v-list>
			</v-menu>
		</v-toolbar>

		<v-content>
			<router-view />
		</v-content>
	</v-app>
</template>

<script>
import firebase from 'firebase'
export default {
	name: 'App',

	computed: {
		categories() {
			const categorySet = new Set()
			categorySet.add('miscellaneous')

			this.$store.state.portfolioConfig.forEach(({ category }) => {
				if (category) {
					categorySet.add(category.toLowerCase().trim())
				}
			})

			const temp = [...categorySet].sort()

			return ['all', ...temp]
		}
	},
	data() {
		return {
			portfolio: { expanded: false },
			firebase,
			menu: [
				{ title: 'HOME', link: '/' },
				{ title: 'CONTACT', link: '/contact' }
			]
		}
	},
	methods: {
		changeCategory(category) {
			this.$store.commit('setCategory', category)
		},

		logOut(firebase) {
			firebase
				.auth()
				.signOut()
				.then(res => {
					this.$store.commit('setToken', ``)
				})
				.catch(err => {
					console.log(err)
				})
		}
	},
	mounted() {
		this.$store.dispatch('loadConfig')
	}
}
</script>
<style scoped>
.activeMenuItem {
	font-weight: bolder;
	border-bottom: 4px;
	border-bottom-style: solid;
	/* border-top: 4px; */
	/* border-top-style: solid; */

	/* border-style: solid; */
	border-color: maroon;
}
.activeMobileMenuItem {
	font-weight: bolder;
	border-left: 4px;
	border-left-style: solid;
	/* border-top: 4px; */
	/* border-top-style: solid; */

	/* border-style: solid; */
	border-color: maroon;
}
</style>
